// utils/permissions.js
import { jwtDecode } from "jwt-decode";

const DEFAULT_ACTIONS = ["view", "add", "edit", "delete", "print", "semua"];

export const getAllPermissions = (moduleName) => {
  try {
    const token = localStorage.getItem("token");
    const decoded = token ? jwtDecode(token) : null;
    const isSuperAdmin = decoded?.role?.toLowerCase() === "superadmin";

    // jika superadmin -> semua true
    if (isSuperAdmin) {
      const res = {};
      DEFAULT_ACTIONS.forEach((a) => (res[a] = true));
      return res;
    }

    // ambil permissions yang disimpan dari login / API
    const stored = localStorage.getItem("permissions");
    if (!stored) {
      // tidak ada data -> default false
      const res = {};
      DEFAULT_ACTIONS.forEach((a) => (res[a] = false));
      return res;
    }

    const permsObj = JSON.parse(stored); // bentuk: { ModuleName: {view: true, ...}, ... }

    // defensive: normalisasi moduleName (jika caller mengirim undefined)
    if (!moduleName) {
      // kembalikan keseluruhan permissions (opsional)
      return permsObj;
    }

    // cari module secara tolerant (case / spacing)
    const normalize = (s) =>
      (s || "").toString().trim().toLowerCase().replace(/\s+/g, "").replace(/[_-]+/g, "");

    const targetNorm = normalize(moduleName);
    let foundKey = Object.keys(permsObj).find((k) => normalize(k) === targetNorm);

    // jika tidak ditemukan persis, coba includes (tolerant)
    if (!foundKey) {
      foundKey = Object.keys(permsObj).find(
        (k) => normalize(k).includes(targetNorm) || targetNorm.includes(normalize(k))
      );
    }

    const modulePerm = foundKey ? permsObj[foundKey] : null;

    const res = {};
    DEFAULT_ACTIONS.forEach((a) => {
      res[a] = !!(modulePerm && modulePerm[a]);
    });

    return res;
  } catch (err) {
    // fallback safe
    const res = {};
    DEFAULT_ACTIONS.forEach((a) => (res[a] = false));
    return res;
  }
};
